// Public, canonical origin of this marketing site. Used for SEO metadata
// (metadataBase, canonical URLs, sitemap, robots, OG/Twitter images).
export const SITE_URL =
  process.env.NEXT_PUBLIC_SITE_URL ?? "https://intelligence.samvolt.com";

// The customer web app lives on its own domain. Configurable so it can point
// at the right host per environment; defaults to production.
const APP_URL =
  process.env.NEXT_PUBLIC_APP_URL ?? "https://app.intelligence.samvolt.com";

export const APP_LOGIN_URL = `${APP_URL}/login`;

// Customer account page (plants, subscription, payment). Logged-out visitors
// are bounced to BankID login and land back here afterwards.
export const APP_ACCOUNT_URL = `${APP_URL}/account`;

// Where a brand-new private user should land right after signing in from a
// trial CTA: straight into the "create plant" onboarding wizard, so they
// aren't dropped on an empty account page and left wondering what to do.
const ADD_PLANT_PATH = "/account/add-plant";

// Trial CTA ("Testa utan kostnad"): log in, then continue to the create-plant
// wizard. The app login reads the `next` query param and redirects there once
// authentication completes.
export const APP_TRIAL_URL = `${APP_LOGIN_URL}?next=${encodeURIComponent(
  ADD_PLANT_PATH,
)}`;

// SavvyCal scheduling link for booking a demo / meeting.
export const BOOK_DEMO_URL = "https://savvycal.com/samvoltintelligence/demo";
